import { AmlFlowEnum } from '@/api';
import { isFlowLite } from '@/helpers';

const isFlowLimited = (flow: AmlFlowEnum | '' = '') => {
  if (!flow) {
    return false;
  }

  return (
    isFlowLite(flow) ||
    [AmlFlowEnum.FAST_LIMITED, AmlFlowEnum.ADVANCED_LIMITED].includes(flow)
  );
};

export default isFlowLimited;
